import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function UsersIcon({ className }: IconProps) {
  return (
    <svg
      width="85"
      height="65"
      viewBox="0 0 85 65"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1471)">
        <path
          d="M52.0467 61.5945C50.8901 52.6499 45.1856 45.1341 37.3638 41.3958C34.1293 43.5879 30.2282 44.8601 26.0331 44.8601C21.838 44.8601 17.937 43.5879 14.722 41.3958C6.88068 45.1341 1.19571 52.6499 0.0195157 61.5945C-0.215724 63.3952 1.21532 65.0001 3.03843 65.0001H49.0278C50.8509 65.0001 52.282 63.3952 52.0467 61.5945Z"
          fill="#00416B"
        />
        <path
          d="M40.1673 24.7003C40.1673 32.4902 33.8355 38.812 26.0333 38.812C18.2312 38.812 11.9189 32.4902 11.9189 24.7003C11.9189 16.9105 18.2312 10.5886 26.0333 10.5886C33.8355 10.5886 40.1673 16.9105 40.1673 24.7003Z"
          fill="#00416B"
        />
        <path
          d="M73.0814 14.1117C73.0814 21.9015 66.7495 28.2234 58.9474 28.2234C51.1453 28.2234 44.833 21.9015 44.833 14.1117C44.833 6.32189 51.1649 0 58.967 0C66.7691 0 73.101 6.32189 73.101 14.1117"
          fill="#00C4B3"
        />
        <path
          d="M84.9799 50.9861C83.8233 42.0415 78.1188 34.5257 70.2971 30.7874C67.0625 32.9795 63.1614 34.2517 58.9663 34.2517C54.7712 34.2517 50.8702 32.9599 47.6552 30.7874C46.4398 31.3745 45.3028 32.0596 44.205 32.8229C43.4013 34.6235 42.3231 36.2872 41.0293 37.7551C47.7532 41.4348 52.8109 47.3456 55.3593 54.4113H81.961C83.7841 54.4113 85.2152 52.8063 84.9799 51.0057V50.9861Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1471">
          <rect width="85" height="65" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
